
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyCardinalWest as ObiSimplifiedBuoyCardinalWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-cardinal-west.js';
 
 
 

 
 export const ObiSimplifiedBuoyCardinalWest = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-cardinal-west',
   elementClass: ObiSimplifiedBuoyCardinalWestElement,
   events: {
     
   }
  });
 
 